
import React from 'react'
import {AppRow,AppRadio} from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row } from 'antd';

const apiData = [
    {attrName:'value',type:'string',defaultValue:'',remarks:'选项的value值'},
    {attrName:'onChange',type:'(value: string, text: string) => void',defaultValue:'',remarks:'选项该改变事件'},
    {attrName:'options',type:'MetadataOption[]',defaultValue:"[{ label: '是', value: '1' }, { label: '否', value: '0' }]",remarks:'可选列表'},
    {attrName:'readonly',type:'boolean',defaultValue:'false',remarks:'readonly'},
   
]

export const AppRadioDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、单选框，需要用户界面交互时使用。<br/>
                2、引用：import {`{AppRadio}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppRadioDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row style={{padding:20}}>
                    <AppRow>
                        <div style={{width:300}}>
                            <AppRadio />
                        </div>
                    </AppRow>
                </Row>
            
                
            </div>
            
            <h1>API</h1>
             <DemoApiTable data={apiData}/>
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppRadioDemo.tsx